"use client";
import { useEffect } from "react";
import { Images } from "@assets/assets";

// Helper to safely extract string URL from next/image StaticImageData or string
function toUrl(img: unknown): string | null {
  if (!img) return null;
  if (typeof img === "string") return img;
  // StaticImageData shape: { src: string, width: number, height: number }
  if (typeof img === "object" && "src" in (img as object)) {
    return (img as { src: string }).src;
  }
  return null;
}

export default function LazyBackgrounds() {
  useEffect(() => {
    const apply = () => {
      try {
        const root = document.body.style;

        const podcast = toUrl(Images?.career?.podcast?.podcastBottomBg);

        if (podcast) root.setProperty("--bg-podcast", `url(${podcast})`);
      } catch (e) {
        console.error("LazyBackgrounds failed:", e);
      }
    };

    // FIX 3: requestIdleCallback is correct — no changes needed here
    // This already runs after paint, so no reflow risk
    if ("requestIdleCallback" in window) {
      const id = (window as any).requestIdleCallback(apply, { timeout: 3000 });
      // FIX 4: cancel on unmount to prevent memory leak
      return () => (window as any).cancelIdleCallback(id);
    } else {
      const id = setTimeout(apply, 2000);
      return () => clearTimeout(id);
    }
  }, []);

  return null;
}
